import { render, staticRenderFns } from "./CaseConfigPermissionTasks.vue?vue&type=template&id=bbc57354"
import script from "./CaseConfigPermissionTasks.vue?vue&type=script&lang=js"
export * from "./CaseConfigPermissionTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports